import { observable } from 'mobx';
import { MonografiaModel } from '../Monografia';
import { PreProjetoModel } from '../PreProjeto';

export class AlunoModel {
  readonly id: number = 0;
  @observable public cpf: string = '';
  @observable public matricula: string = '';
  @observable public nome: string = '';
  @observable public email: string = '';
  @observable public serie: string = '';
  @observable public turma: string = '';
  @observable public alunoAtivo: boolean=true;
  @observable public sit: string='';
  @observable public monografia?: MonografiaModel;
  @observable public preProjeto?: PreProjetoModel;
}